import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=d70e95f6&"
import script from "./Photography.vue?vue&type=script&lang=js&"
export * from "./Photography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports